import type { ArrayFieldItemTemplateProps } from '@rjsf/utils'
import { SkrottlappScanProvider } from '../../../hooks/useSkrottlappScan'
import { Mtds, TrashIcon } from 'prove-common'
import { SkrottlappParsed } from '../../../types/types'
import { isValidElement } from 'react'

export const ArrayFieldItemTemplate = ({
  children,
  buttonsProps,
  index,
  disabled
}: ArrayFieldItemTemplateProps) => {
  const { hasRemove, onRemoveItem } = buttonsProps
  const skrottlappScan: SkrottlappParsed | undefined =
    isValidElement(children) && children.props
      ? (
          children.props as {
            formData?: { payload?: { skrottlappScan?: SkrottlappParsed } }
          }
        ).formData?.payload?.skrottlappScan
      : undefined
  return (
    <SkrottlappScanProvider skrottlappScan={skrottlappScan} index={index}>
      <Mtds.Card as={Mtds.Grid} className='mt-4'>
        <Mtds.Flex data-align='center' data-justify='space-between'>
          <Mtds.Heading data-size='2xs' as='h5'>
            Delprøve
          </Mtds.Heading>
          {hasRemove && (
            <Mtds.Button disabled={disabled} onClick={onRemoveItem}>
              <TrashIcon />
            </Mtds.Button>
          )}
        </Mtds.Flex>
        {children}
      </Mtds.Card>
    </SkrottlappScanProvider>
  )
}
